export const getScrollbarWidth = () => {
  const outer = document.createElement('div');

  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  (outer.style as CSSStyleDeclaration & { msOverflowStyle: 'scrollbar' }).msOverflowStyle = 'scrollbar';
  
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

  outer.parentNode?.removeChild(outer);

  return scrollbarWidth;
};

export const disableScroll = () => {
  const hasScroll = document.body.scrollHeight > document.body.clientHeight;

  if (hasScroll) {
    document.body.style.overflowY = 'hidden';
    document.body.style.paddingRight = `${getScrollbarWidth()}px`;
  }
};

export const enableScroll = () => {
  document.body.style.overflowY = 'auto';
  document.body.style.paddingRight = '0';
};